'use client'

import { useEffect } from 'react'
import { useReducedMotion, useSpring } from 'framer-motion'

/** A critically damped drawer: no bounce, with velocity retained on reversal. */
export default function useDrawerSpring(open: boolean, immediate = false) {
	const reducedMotion = useReducedMotion()
	const progress = useSpring(open ? 1 : 0, {
		stiffness: 240,
		damping: 31,
		mass: 1,
		restDelta: 0.0005,
		restSpeed: 0.005,
	})

	useEffect(() => {
		if (reducedMotion || immediate) progress.jump(open ? 1 : 0)
		else progress.set(open ? 1 : 0)
	}, [open, immediate, reducedMotion, progress])

	return progress
}
